import React from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button, Toggler, Tooltip } from '@components';
import { AutopatrocinioInitialValues, AutopatrocinioSchema } from '@schemas';
import {
  concluirEnvioRequerimento,
  enviarRequerimentoFormulario,
} from '../../../../store/requerimentos/thunks';

export const AutopatrocinioTaesa = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const envioLoading = useSelector(
    (state) => state.requerimentos.envio.loading
  );

  const handleFormSubmit = (values) => {
    dispatch(
      enviarRequerimentoFormulario({
        campos: values,
        formulario: reference,
      })
    )
      .unwrap()
      .then(({ protocolo }) =>
        dispatch(concluirEnvioRequerimento({ formulario: reference }))
          .unwrap()
          .then(() => protocolo)
      )
      .then((protocolo) => {
        toast.success(
          `Requerimento enviado com sucesso! O número do seu protocolo é: ${protocolo}`
        );
        navigate('/requerimentos/andamento');
      })
      .catch(() => {
        toast.error(
          'Erro ao enviar requerimento. Favor re-logar e tentar novamente.'
        );
      });
  };

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        <p className="mb-3">
          Venho, por meio deste, exercer a opção pelo Autopatrocínio, me
          comprometendo a recolher mensalmente à Entidade o valor das
          Contribuições do participante e da Patrocinadora e, quando houver, e a
          Despesa Administrativa, para assegurar a percepção dos benefícios
          conforme previsto no Regulamento do Plano Taesa de Benefícios
          Previdenciários (Plano Taesaprev), sujeitando-me, em caso de não
          cumprimento dessa obrigação às penalidades previstas no Regulamento.
          <Tooltip title="Instituto que faculta o participante a continuar contribuindo para o plano previdenciário, retroativamente à data do desligamento da Patrocinadora, assumindo as contribuições individual e patronal mais a taxa administrativa, que é apurada anualmente com base no saldo da conta de aposentadoria. O cálculo da contribuição mensal como autopatrocinado é sobre o último salário real de contribuição em atividade, atualizado anualmente pelo Índice Atuarial do Plano (IPCA-IBGE). Ao optar pelo autopatrocínio o participante permanecerá com o nível de contribuição atual podendo alterar o percentual de contribuição e o perfil de investimento de acordo com as regras vigentes e até mesmo suspender as contribuições temporariamente. A opção pelo autopatrocínio possibilita posterior opção pelo BPD, Portabilidade ou Resgate.">
            ?
          </Tooltip>
        </p>
        <Formik
          validateOnMount
          initialValues={AutopatrocinioInitialValues}
          validationSchema={AutopatrocinioSchema}
          onSubmit={handleFormSubmit}
        >
          {({ handleSubmit, isValid }) => {
            return (
              <Form>
                <div className="row">
                  <Field
                    name="aceite"
                    component={Toggler}
                    label="Declaro estar ciente de que as contribuições vertidas ao Plano de Benefício serão entendidas como contribuição do participante."
                  />
                </div>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        disabled={!isValid || envioLoading}
                        className="ms-0 ms-md-3"
                        onClick={handleSubmit}
                      >
                        Continuar
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};
